import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.black,
  iconHoverColor: colors.deepOrange,
  iconBorderColor: colors.black,
  iconBorderHoverColor: colors.deepOrange
};
export default socialIcon;